import React from 'react'
import { Form, Input, Typography } from 'antd'
import PropTypes from 'prop-types'

import { antFormItemNamePropType } from '../../prop-types'
import {
  formatFormLabel,
  getFormItemLabelAboveConfiguration,
} from '../../utils'

const FormTextareaInput = ({
  name,
  label,
  rules,
  labelAbove,
  showColon,
  ...rest
}) => (
  <Form.Item
    layout="vertical"
    labelCol={getFormItemLabelAboveConfiguration(labelAbove)}
    fieldKey={name}
    name={name}
    colon
    label={
      <Typography.Text>{formatFormLabel(label, showColon)}</Typography.Text>
    }
    rules={rules}
  >
    <Input.TextArea {...rest} />
  </Form.Item>
)

FormTextareaInput.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  labelAbove: PropTypes.bool,
  showColon: PropTypes.bool,
}

FormTextareaInput.defaultProps = {
  label: '',
  rules: undefined,
  labelAbove: false,
  showColon: true,
}

export default FormTextareaInput
